import { useSnapshot } from 'valtio'
import { mapSelectionAtom } from '../mapSelection'

export function useMapSelectionContext() {
  const context = useSnapshot(mapSelectionAtom.context)
  return context
}
